export default __webpack_public_path__ + "b50be179812bc7f8955d6b708fb25fc1.png";